import React, { useState } from 'react';

import { ClientPaymentsContext } from '@app/providers/ClientPaymentsProvider/ClientPaymentsContext';
import type { NClientPaymentsProvider } from '@app/providers/ClientPaymentsProvider/ClientPaymentsProvider.types';

const Context = React.createContext('');

export const ClientPaymentsProvider: NClientPaymentsProvider.Main = ({
  children,
}) => {
  const [isPaymentsModalOpen, setIsPaymentsModalOpen] = useState(false);
  const [isCollectionsModalOpen, setIsCollectionsModalOpen] = useState(false);
  const [isExpensesModalOpen, setIsExpensesModalOpen] = useState(false);

  const [searchId, setSearchId] = useState<number | null>(null);

  return (
    <ClientPaymentsContext.Provider
      value={{
        isPaymentsModalOpen,
        setIsPaymentsModalOpen,
        isCollectionsModalOpen,
        setIsCollectionsModalOpen,
        isExpensesModalOpen,
        setIsExpensesModalOpen,
        searchId,
        setSearchId,
      }}
    >
      <Context.Provider value={''}>{children}</Context.Provider>
    </ClientPaymentsContext.Provider>
  );
};
